var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.$t("Menu.AdministratorInitializationOperationGuidance"),
        visible: _vm.innerVisible,
        "append-to-body": ""
      },
      on: { close: _vm.handleClose }
    },
    [
      _c("ul", [
        _c("li", [
          _c("h4", [
            _vm._v(_vm._s(_vm.$t("Menu.ImproveEnterpriseInformation")))
          ]),
          _c(
            "p",
            [
              _vm._v(
                _vm._s(
                  _vm.$t("Menu.PleaseImproveYourCompanyEnterpriseInformation")
                ) + "，"
              ),
              _c(
                "el-link",
                {
                  attrs: {
                    type: "primary",
                    href: _vm.initCompany,
                    target: "_blank"
                  }
                },
                [_vm._v(_vm._s(_vm.$t("Menu.ViewTheSteps")))]
              )
            ],
            1
          )
        ]),
        _c("li", [
          _c("h4", [_vm._v(_vm._s(_vm.$t("Menu.CreateAUser")))]),
          _c(
            "p",
            [
              _vm._v(
                _vm._s(_vm.$t("Menu.CreateOurUsersAndSetPermissions")) + "，"
              ),
              _c(
                "el-link",
                {
                  attrs: {
                    type: "primary",
                    href: _vm.initUser,
                    target: "_blank"
                  }
                },
                [_vm._v(_vm._s(_vm.$t("Menu.ViewTheSteps")))]
              )
            ],
            1
          )
        ]),
        _c("li", [
          _c("h4", [_vm._v(_vm._s(_vm.$t("Menu.CustomerDataImport")))]),
          _c(
            "p",
            [
              _vm._v(
                _vm._s(
                  _vm.$t(
                    "Menu.InitializeAndImportTheCompanyOriginalCustomerInformation"
                  )
                ) + "，"
              ),
              _c(
                "el-link",
                {
                  attrs: {
                    type: "primary",
                    href: _vm.initClient,
                    target: "_blank"
                  }
                },
                [_vm._v(_vm._s(_vm.$t("Menu.ViewTheSteps")))]
              )
            ],
            1
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }